import { render, staticRenderFns } from "./TsIBranchFilter.vue?vue&type=template&id=59420573&scoped=true&"
import script from "./TsIBranchFilter.vue?vue&type=script&lang=js&"
export * from "./TsIBranchFilter.vue?vue&type=script&lang=js&"
import style0 from "./TsIBranchFilter.vue?vue&type=style&index=0&id=59420573&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59420573",
  null
  
)

export default component.exports